export default __webpack_public_path__ + "static/media/3155-gerry.e470a93a.pdf";